import { Loading } from "@wfp/ui"

interface OverlayLoaderProps {
  active?: boolean
}

export default function OverlayLoader({ active }: OverlayLoaderProps) {
  if (!active) return null

  return (
    <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-black/5">
      <Loading {...{ active }} withOverlay={false} />
    </div>
  )
}
